export class ValidationError<T> extends Error {
  fieldName: T;

  constructor(message: string, fieldName: T) {
    super(message);
    this.fieldName = fieldName;
  }
}
